module.exports = __webpack_public_path__ + "assets/no-reorders-b7170b.svg";